import React, { Component } from "react";
import {
  Button,
  PageHeader,
  ListGroup,
  ControlLabel,
  Glyphicon,
  FormControl,
  Thumbnail
} from "react-bootstrap";
import "./Friend.css";
import { API } from "aws-amplify";
import FacebookFriend from "../components/FacebookFriend";

export default class Friend extends Component {
  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }
  }

  popUpFriend = function(data) {
    console.log("Popup Book: ", data);
    //var response = API.post("books", "user/book", {body : {'ISBN': data.volumeInfo.industryIdentifiers[0].identifier,'Info': data}});
    //console.log('response: ', response);
    return false;
  };

  render() {
    let friends = JSON.parse(localStorage.getItem("friendList"));
    console.log("Friends:", friends);
    let friendList = (
      <ul className="list-group">
        {" "}
        {friends
          ? friends.map((Friend, i) => {
              return (
                <FacebookFriend
                  key={i}
                  src={Friend}
                  onClick={() => {
                    this.openFriendModal(Friend);
                  }}
                  onFriendRequest={() => {
                    this.requestConnection(Friend);
                  }}
                />
              );
            })
          : ""}
      </ul>
    );
    return (
      <div className="Friends">
        <PageHeader>Your Friends</PageHeader>
        <Button
          key="addnew"
          href="/friend/add"
          bsSize="sm"
          className="bf"
          bsStyle="primary"
        >
          <b>{"\uFF0B"}</b> Search Friends
        </Button>
        {friendList}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Friends.js